import React, { useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useAuth } from './AuthContext';
import toast from 'react-hot-toast';
import Slider from "react-slick";
import CustomsFeed from './CustomsFeed';

// CSS Slider
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const API_URL = 'https://rys-backend.onrender.com/api';

// --- Icons ---

// --- ไอคอน (ปรับปรุงให้รับขนาดผ่าน className ได้ และไม่โดนตัด) ---

// 1. ปุ่มแก้ไข (Pencil)
const PencilIcon = ({ className = "w-5 h-5 text-blue-600" }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={1.5} 
    stroke="currentColor" 
    className={className}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
  </svg>
);

// 2. ปุ่มลบ (Trash)
const TrashIcon = ({ className = "w-5 h-5 text-red-600" }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={1.5} 
    stroke="currentColor" 
    className={className}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
  </svg>
);

// 3. ปุ่มค้นหา (Search)
const SearchIcon = ({ className = "w-5 h-5 text-gray-500" }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={2} 
    stroke="currentColor" 
    className={className}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
  </svg>
);

// 4. ดาวปักหมุด (Star - แบบ Solid เต็มดวง)
const StarIcon = ({ className = "w-6 h-6 text-yellow-500" }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={2}
    stroke="currentColor" 
    className={className}
  >
    <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z" clipRule="evenodd" />
  </svg>
);

// 5. ลูกศรซ้าย (Chevron Left)
const ChevronLeftIcon = ({ className = "w-6 h-6" }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={2} 
    stroke="currentColor" 
    className={className}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
  </svg>
);

// 6. ลูกศรขวา (Chevron Right)
const ChevronRightIcon = ({ className = "w-6 h-6" }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={2} 
    stroke="currentColor" 
    className={className}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
  </svg>
);

// 1. ไอคอนเอกสารทั้งหมด (ตึก)
const AllDocsIcon = ({ className = "w-6 h-6" }) => ( // ลบ text-gray-700 ออก
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={2} 
    stroke="currentColor" // สำคัญ: ต้องเป็น currentColor
    className={className}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
  </svg>
);

// 2. ไอคอนปักหมุด
const PinIcon = (props) => ( // ลบ text-gray-700 ออก
  <svg {...props}
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={2} 
    stroke="currentColor" 
    className={props.className || "w-6 h-6"}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z" />
  </svg>
);

// 3. ไอคอนล่าสุด
const RecentIcon = ({ className = "w-6 h-6" }) => ( // ลบ text-gray-700 ออก
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={2} 
    stroke="currentColor" 
    className={className}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
  </svg>
);
// --- Components ---

// แก้ไข 2: ลบพื้นหลังสีเทาของคำว่า "เปิดอ่าน"
function FeaturedFilesCompact({ files }) {
  if (!files || files.length === 0) return null;
  return (
    <div className="w-full"> 
      <h3 className="text-xl font-bold text-gray-800 mb-6 flex items-center border-b pb-3 border-gray-200">
        <StarIcon /> <span className="ml-2">เอกสารอ้างอิงหลัก (Quick Access)</span>
      </h3>
      
      <div className="flex flex-row w-full gap-4" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        {files.map((file) => (
          <a 
            key={file.id} 
            href={file.pdf_url} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="group flex flex-col bg-white rounded-lg shadow-sm hover:shadow-xl border border-gray-200 transition-all duration-300 overflow-hidden hover:border-blue-500 hover:-translate-y-1"
            style={{ width: '33.33%', minWidth: '0' }} 
          >
            <div className="w-full bg-gray-50 overflow-hidden relative border-b border-gray-100" style={{ height: '160px' }}>
              <img 
                src={file.image_url} 
                alt={file.title} 
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" 
              />
            </div>
            
            <div className="p-3 flex-grow flex flex-col justify-between">
              <p className="text-xs md:text-sm font-bold text-gray-800 group-hover:text-blue-700 line-clamp-2 mb-2 leading-snug">
                {file.title}
              </p>
              
              <div className="mt-auto pt-1">
                 {/* เอา bg-gray-100 ออก และปรับสี text ให้ชัดขึ้น */}
                 <span className="inline-block text-[10px] md:text-[11px] uppercase tracking-wider text-gray-400 group-hover:text-blue-600 transition-colors font-medium">
                    คลิกเพื่อเปิดไฟล์ pdf
                 </span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}

function AnnouncementCarousel({ announcements }) {
  if (!announcements || announcements.length === 0) return null;
  const settings = { dots: true, infinite: true, speed: 600, slidesToShow: 1, slidesToScroll: 1, autoplay: true, autoplaySpeed: 6000, pauseOnHover: true, arrows: true };
  return (
    <div className="shadow-lg rounded-2xl overflow-hidden bg-white relative group border border-gray-100 w-full">
      <Slider {...settings}>
        {announcements.map((ann) => (
          <div key={ann.id} className="relative w-full aspect-[21/9] md:aspect-[3.5/1] outline-none bg-gray-100">
            <a href={ann.link_url} target="_blank" rel="noopener noreferrer" className="block w-full h-full">
               <img src={ann.image_url} alt={ann.title} className="w-full h-full object-cover object-center block" />
            </a>
          </div>
        ))}
      </Slider>
    </div>
  );
}

// แก้ไข 4: แยก Sidebar ออกมาเป็น Component อิสระ (อยู่นอก Dashboard)
// เพื่อป้องกันการ Re-render และ Re-fetch ข้อมูลเมื่อ State ของ Dashboard เปลี่ยน
const Sidebar = ({ isOpen, setIsOpen }) => {
    if (typeof document === 'undefined') return null;

    return ReactDOM.createPortal(
        <>
            {/* Overlay */}
            <div 
                className={`fixed inset-0 bg-black/60 z-[9998] transition-opacity duration-300 backdrop-blur-sm ${isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
                onClick={() => setIsOpen(false)}
                style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }}
            />
            
            {/* Drawer */}
            <div 
                className="fixed top-0 right-0 h-full bg-white shadow-2xl flex border-l border-gray-200 z-[9999] transition-transform duration-300 ease-in-out"
                style={{
                    width: '85%',
                    maxWidth: '700px',
                    transform: isOpen ? 'translateX(0)' : 'translateX(100%)',
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    bottom: 0,
                    height: '100vh',
                    zIndex: 9999
                }}
            >
                {/* ปุ่ม Toggle */}
                <button
                    onClick={() => setIsOpen(!isOpen)}
                    className="absolute w-14 h-16 bg-blue-600 text-white rounded-l-xl shadow-lg flex items-center justify-center focus:outline-none hover:bg-blue-700 transition-colors cursor-pointer border-l border-t border-b border-white/20"
                    style={{ top: '120px', left: '-56px', zIndex: 10000, position: 'absolute' }}
                >
                    {isOpen ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                </button>

                {/* เนื้อหา */}
                <div className="w-full h-full flex flex-col overflow-hidden relative">
                    <div className="p-5 bg-white border-b border-gray-200 flex items-center justify-between shrink-0 shadow-sm z-10 relative">
                        <h2 className="text-xl font-bold text-gray-800 flex items-center">
                            <span className="mr-3 text-2xl">🔔</span> Live Customs Feed
                        </h2>
                        <button onClick={() => setIsOpen(false)} className="text-gray-400 hover:text-gray-600 md:hidden p-2">✕ ปิด</button>
                    </div>
                    <div className="p-0 flex-grow overflow-y-auto bg-gray-50 relative">
                        {/* CustomsFeed จะถูก Mount เพียงครั้งเดียว และไม่ Unmount เมื่อปิด Sidebar */}
                        <CustomsFeed inSidebar={true} />
                    </div>
                </div>
            </div>
        </>,
        document.body 
    );
};

// --- Main Dashboard Component ---

function Dashboard() {
  const [announcements, setAnnouncements] = useState([]);
  const [featuredFiles, setFeaturedFiles] = useState([]); 
  const [documents, setDocuments] = useState([]);
  const [categories, setCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { isAuthenticated, user, getAuthHeaders } = useAuth();
  
  const [pageTitle, setPageTitle] = useState('เอกสารทั้งหมด');
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [searchPage, setSearchPage] = useState(1);
  const [searchTotalPages, setSearchTotalPages] = useState(1);
  const [recentPage, setRecentPage] = useState(1);
  const [recentTotalPages, setRecentTotalPages] = useState(1);
  const [pinnedPage, setPinnedPage] = useState(1);
  const [pinnedTotalPages, setPinnedTotalPages] = useState(1);
  const [pinnedDocs, setPinnedDocs] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [deletingDoc, setDeletingDoc] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const fetchAnnouncements = useCallback(async () => { try { const res = await axios.get(`${API_URL}/announcements`); setAnnouncements(res.data); } catch (err) {} }, []);
  const fetchFeaturedFiles = useCallback(async () => { try { const res = await axios.get(`${API_URL}/featured-files`); setFeaturedFiles(res.data); } catch (err) {} }, []);
  const fetchCategories = useCallback(async () => { try { const res = await axios.get(`${API_URL}/categories`); setCategories(res.data); } catch (err) {} }, []);
  const fetchPinned = useCallback(async (page = 1) => { try { const res = await axios.get(`${API_URL}/documents/pinned?page=${page}`); setPinnedDocs(prev => page === 1 ? res.data.documents : [...prev, ...res.data.documents]); setPinnedTotalPages(res.data.total_pages); } catch (err) { } }, []);
  const fetchData = useCallback(async (query = '', category = '', page = 1) => {
    if (page === 1) setIsLoading(true);
    if (page > 1) setIsLoadingMore(true);
    const docUrl = `${API_URL}/documents?q=${encodeURIComponent(query)}&category_id=${encodeURIComponent(category)}&page=${page}`;
    try {
        if (categories.length === 0) {
            const catUrl = `${API_URL}/categories`;
            const [docsResponse, catsResponse] = await Promise.all([axios.get(docUrl), axios.get(catUrl)]);
            setCategories(catsResponse.data);
            setDocuments(prev => page === 1 ? docsResponse.data.documents : [...prev, ...docsResponse.data.documents]);
            if (query || category) setSearchTotalPages(docsResponse.data.total_pages); else setRecentTotalPages(docsResponse.data.total_pages);
        } else {
            const docsResponse = await axios.get(docUrl);
            setDocuments(prev => page === 1 ? docsResponse.data.documents : [...prev, ...docsResponse.data.documents]);
            if (query || category) setSearchTotalPages(docsResponse.data.total_pages); else setRecentTotalPages(docsResponse.data.total_pages);
        }
    } catch (error) { toast.error("โหลดเอกสารไม่สำเร็จ"); } finally { setIsLoading(false); setIsLoadingMore(false); }
  }, [categories.length]);

  useEffect(() => { fetchCategories(); fetchPinned(1); fetchData('', '', 1); fetchAnnouncements(); fetchFeaturedFiles(); }, [fetchData, fetchPinned, fetchCategories, fetchAnnouncements, fetchFeaturedFiles]); 

  const handleSearch = (e) => { e.preventDefault(); setSearchPage(1); fetchData(searchTerm, selectedCategory, 1); };
  const loadMore = (type) => { if (type === 'pinned') { const nextPage = pinnedPage + 1; setPinnedPage(nextPage); fetchPinned(nextPage); } else if (type === 'search') { const nextPage = searchPage + 1; setSearchPage(nextPage); fetchData(searchTerm, selectedCategory, nextPage); } else { const nextPage = recentPage + 1; setRecentPage(nextPage); fetchData('', '', nextPage); } };
  const handleClearSearch = () => { setSearchTerm(''); setSelectedCategory(''); setIsSearching(false); setSearchPage(1); setRecentPage(1); setPinnedPage(1); fetchPinned(1); fetchData('', '', 1); };
  const handleOpenDeleteModal = (doc) => { setDeletingDoc(doc); setIsDeleteModalOpen(true); };
  const handleConfirmDelete = async () => {
    if (!deletingDoc) return;
    try { await axios.delete(`${API_URL}/documents/${deletingDoc.id}`, getAuthHeaders()); toast.success(`ลบเอกสารสำเร็จ!`); setRecentPage(1); setSearchPage(1); setPinnedPage(1); fetchPinned(1); fetchData(searchTerm, selectedCategory, 1); } catch (error) { toast.error('ลบไม่สำเร็จ'); } finally { setIsDeleteModalOpen(false); setDeletingDoc(null); }
  };

  const renderDocumentListItem = (doc) => (
    <div key={doc.id} className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-all border border-gray-100 mb-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5 group">
      <div className="flex-grow min-w-0">
        
        {/* ปรับปรุง Layout:
            - ใช้ flex-wrap เพื่อให้ตกบรรทัดได้ถ้าจอเล็ก
            - ใช้ gap-6 (24px) เพื่อเว้นระยะห่างแนวนอนให้ชัดเจน
            - items-baseline เพื่อให้ตัวหนังสือวางแนวบรรทัดเดียวกันสวยงาม 
        */}
        <div className="flex flex-wrap items-baseline gap-x-6 gap-y-2 mb-2">
            
            {/* ส่วนชื่อเอกสาร */}
            <div className="flex items-center">
                {doc.is_pinned && <span className="mr-5 text-yellow-500 text-lg" title="Pinned"><StarIcon /></span>}
                <h4 className="text-lg font-bold text-gray-800 hover:text-blue-700 transition-colors cursor-pointer leading-tight">
                    {doc.title}
                </h4>
            </div>

            {/* ส่วนหมวดหมู่และ Tags */}
            <div className="flex flex-wrap items-center gap-3">
                {/* หมวดหมู่ (สีฟ้า) */}
                <span className="text-blue-600 font-semibold text-sm bg-blue-50 px-3 py-1 rounded-md border border-blue-100 whitespace-nowrap">
                    {doc.category || 'ทั่วไป'}
                </span>

                {/* Tags (สีเทา) */}
                {doc.tags && doc.tags.map((tag, idx) => (
                    <span key={idx} className="text-gray-500 text-sm bg-gray-100 px-3 py-1 rounded border border-gray-200 whitespace-nowrap">
                        #{tag}
                    </span>
                ))}
            </div>
        </div>

        {/* บรรทัดที่ 2: คำอธิบาย */}
        {doc.description && (
            <p className="text-sm text-gray-500 line-clamp-2 leading-relaxed mt-1 pl-1">
                {doc.description}
            </p>
        )}
      </div>

      <div className="flex items-center gap-4 flex-shrink-0">
         {isAuthenticated && user && user.role === 'admin' && (
            <>
              <Link to={`/edit/${doc.id}`} className="p-2 text-gray-400 hover:text-yellow-600 hover:bg-yellow-50 rounded-full transition-colors"><PencilIcon /></Link>
              <button onClick={() => handleOpenDeleteModal(doc)} className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-full transition-colors"><TrashIcon /></button>
            </>
          )}
         <a href={doc.google_drive_link} target="_blank" rel="noopener noreferrer" className="px-6 py-3 bg-blue-600 text-white text-base font-semibold rounded-lg hover:bg-blue-700 shadow-md hover:shadow-lg transition-all whitespace-nowrap">เปิดอ่าน</a>
      </div>
    </div>
  );

  return (
    <React.Fragment>
      
      {/* Sidebar ถูกเรียกใช้นอกเงื่อนไขการ Render เพื่อให้คงสถานะไว้ */}
      <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />

      <div className="w-full p-4 sm:p-6 lg:p-8 flex flex-col min-h-screen bg-gray-50 relative z-0">
        <div className="max-w-7xl mx-auto w-full pb-24">
            
            {/* 1. ประกาศ */}
            <AnnouncementCarousel announcements={announcements} />

            <div style={{ height: '20px' }}></div>

            {/* 2. เอกสารอ้างอิง */}
            <FeaturedFilesCompact files={featuredFiles} />

            <div style={{ height: '20px' }}></div>

            {/* 3. ส่วนค้นหาเอกสาร (แก้ไขระยะห่างช่องไฟ: gap-6) */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
                <form onSubmit={handleSearch} className="flex flex-row gap-6 items-center w-full">
                    <div className="relative flex-grow">
                        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none"><SearchIcon /></div>
                        <input type="text" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="block w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg leading-5 bg-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-base transition-shadow" placeholder="พิมพ์คำค้นหา..." />
                    </div>
                    <div className="shrink-0 min-w-[200px] max-w-[300px]">
                        <select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)} className="block w-full pl-3 pr-8 py-3 text-base border border-gray-800 focus:border-black focus:ring-1 focus:ring-black rounded-lg bg-white shadow-sm cursor-pointer hover:bg-gray-50 transition-colors text-gray-800 font-medium truncate">
                            <option value="">ทุกหมวดหมู่</option>
                            {categories.map(cat => <option key={cat.id} value={cat.id}>{cat.name}</option>)}
                        </select>
                    </div>
                    <div className="shrink-0">
                        <button type="submit" className="px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 shadow-md hover:shadow-lg transition-all transform active:scale-95 whitespace-nowrap">ค้นหา</button>
                    </div>
                     {isSearching && <div className="shrink-0"><button type="button" onClick={handleClearSearch} className="px-4 py-3 border border-gray-300 text-base font-medium rounded-lg text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-all whitespace-nowrap">ล้าง</button></div>}
                </form>
            </div>

            <div style={{ height: '20px' }}></div>

            {/* 4. รายการเอกสาร */}
            <div>
                <h3 className="text-2xl font-bold text-gray-800 mb-8 border-b pb-3 flex items-center border-gray-300">
                    {isSearching ? (
                        <>🔍 ผลการค้นหา</>
                    ) : (
                        <>
                            <AllDocsIcon className="w-6 h-6 mr-3 text-blue-600" /> {/* ใส่ไอคอนตึก */}
                            เอกสารทั้งหมด
                            </>
                    )}
                </h3>
                {isLoading ? ( <div className="flex justify-center py-20"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div></div> ) : (
                   <>
                     {!isSearching && pinnedDocs.length > 0 && (
                        <div className="mb-12">
                            <div className="flex items-center mb-6"><PinIcon className="w-6 h-6 mr-3 transform -rotate-45" style={{ color: '#ef4444' }} /><h4 className="text-xl font-bold text-gray-800">ปักหมุด/แนะนำ</h4></div>
                            <div className="space-y-4">{pinnedDocs.map(renderDocumentListItem)}</div>
                            {pinnedPage < pinnedTotalPages && ( <div className="mt-6 text-center"><button onClick={() => loadMore('pinned')} disabled={isLoadingMore} className="text-blue-600 hover:text-blue-800 text-sm font-medium hover:underline">โหลดเอกสารปักหมุดเพิ่มเติม...</button></div> )}
                        </div>
                     )}
                     {documents.length > 0 ? (
                        <>
                            {!isSearching && pinnedDocs.length > 0 && (<div className="flex items-center mb-6 mt-10"><RecentIcon className="w-6 h-6 mr-3 text-purple-600" /><h4 className="text-xl font-bold text-gray-800">รายการล่าสุด</h4></div>)}
                            <div className="space-y-4">{documents.map(renderDocumentListItem)}</div>
                            {(isSearching ? searchPage < searchTotalPages : recentPage < recentTotalPages) && (<div className="mt-10 text-center"><button onClick={() => loadMore(isSearching ? 'search' : 'recent')} disabled={isLoadingMore} className="px-8 py-3 bg-white border border-gray-300 text-gray-700 font-medium rounded-full shadow-sm hover:bg-gray-50 hover:shadow-md disabled:opacity-50 transition-all">{isLoadingMore ? 'กำลังโหลด...' : 'แสดงเพิ่มเติม'}</button></div>)}
                        </>
                    ) : ( documents.length === 0 && pinnedDocs.length === 0 && ( <div className="text-center py-20 bg-white rounded-xl border-2 border-dashed border-gray-200"><h3 className="mt-4 text-lg font-medium text-gray-900">ไม่พบเอกสาร</h3></div> ) )}
                   </>
                )}
            </div>
        </div>
        {isDeleteModalOpen && deletingDoc && (
            <div className="fixed inset-0 z-[10001] flex items-center justify-center p-4 bg-black bg-opacity-60 backdrop-blur-sm">
                <div className="bg-white w-full max-w-sm p-6 rounded-2xl shadow-2xl transform transition-all scale-100">
                    <h3 className="text-xl leading-6 font-bold text-gray-900 mb-3 text-center">ยืนยันการลบ</h3>
                    <p className="text-sm text-gray-500 mb-6 px-2 text-center">คุณแน่ใจหรือไม่ที่จะลบเอกสาร <br/>"<span className="font-bold text-gray-800">{deletingDoc.title}</span>"?</p>
                    <div className="flex justify-center gap-3">
                        <button onClick={() => setIsDeleteModalOpen(false)} className="px-5 py-2.5 bg-white border border-gray-300 rounded-xl text-gray-700 hover:bg-gray-50 font-medium focus:outline-none transition-colors w-1/2">ยกเลิก</button>
                        <button onClick={handleConfirmDelete} className="px-5 py-2.5 bg-red-600 rounded-xl text-white hover:bg-red-700 font-medium focus:outline-none shadow-lg shadow-red-200 transition-all w-1/2">ลบเอกสาร</button>
                    </div>
                </div>
            </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default Dashboard;